// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusBar__statusBar___DGKhI {
	position: fixed;
	bottom: 60px;
	left: 0px;

	/* Do not remove this width: 100%  */
	width: 100%;

	text-align: center;
	display: inline;
	padding: 3px 10px;
	font-size: 10px;
	opacity: 0.6;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusBar": `StatusBar__statusBar___DGKhI`
};
module.exports = ___CSS_LOADER_EXPORT___;
